import React from 'react';
import { useAuthStore } from '../../store';

import SuccessImage from '../../assets/images/auth/email-verified-success.png';
import BaseImage from '../../components/base/base-image';

const SuccessPage: React.FC = () => {
  const { signedUpEmail } = useAuthStore();

  return (
    <div className="flex items-center justify-center min-h-screen bg-white email-verified-bg">
      <div className="max-w-md p-6 bg-transparent text-center">
        <div className="flex justify-center mb-4">
          <BaseImage
            imgSrc={SuccessImage}
            imgAlt="Success"
            imgClass="mb-4 w-44"
          />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          Welcome Aboard! {signedUpEmail}
        </h1>
        <p className="text-sm">
          Check your email for the verification link sent to you and click.
        </p>
        <p></p>
      </div>
    </div>
  );
};

export default SuccessPage;
